__turbopack_context__.v({
  "SubscribeLine": "SubscribeLine-module-scss-module__S3ukaa__SubscribeLine",
  "SubscribeLine__Item": "SubscribeLine-module-scss-module__S3ukaa__SubscribeLine__Item",
  "SubscribeLine__ItemLink": "SubscribeLine-module-scss-module__S3ukaa__SubscribeLine__ItemLink",
  "SubscribeLine__ItemSubtitle": "SubscribeLine-module-scss-module__S3ukaa__SubscribeLine__ItemSubtitle",
  "SubscribeLine__ItemTitle": "SubscribeLine-module-scss-module__S3ukaa__SubscribeLine__ItemTitle",
  "text": "SubscribeLine-module-scss-module__S3ukaa__text",
});
